/*
  If you want to disable shadow dom in css-oom-generic.tsx,
  change :host to web component name, i.e.
  css-css-oom-generic
*/

.rating {
  display: flex;
  justify-content: center;
  padding: 25px;
}

.ratings {
  display: flex;
  justify-content: center;

  &__star {
    &:not(:first-child) {
      margin-left: 5px;
    }

    &:not(.active) {
      color: #999;

      &:hover {
        color: #767676;
        cursor: pointer;
      }
    }

    &.active {
      background-color: blue;
      color: white;

      &:hover {
        color: lightblue;
        cursor: pointer;
      }
    }
  }
}
